import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from 'environments';
import { VehicleType } from 'models';
import { store } from 'store';

export const vehicleTypeApi = createApi({
    reducerPath: 'vehicle-type-api',
    baseQuery: fetchBaseQuery({
        fetchFn(input, init) {
            const authState = store.getState().auth.token as any;
            return fetch(input, { ...init, headers: { authorization: authState!, 'content-type': 'application/json' } });
        },
        baseUrl: `${env.reactAppSocketUrl}${env.apiUrl}`
    }),
    endpoints: builder => ({
        getVehicleTypes: builder.query<VehicleType[], void>({
            query: () => ({
                url: '/vehicle-types',
                method: 'GET'
            })
        })
    })
});

export const { useLazyGetVehicleTypesQuery, useGetVehicleTypesQuery } = vehicleTypeApi;
